
import {defineComponent, PropType} from 'vue'
import {MailingMailTemplateOverviewRestDto} from '@/api/pharma-master-mailing-template-library/models'

import {UIStateDto} from '@/dtos/UIStateDto'
// import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";

export default defineComponent({
  name: 'MailingMailTemplateOverviewItem',
  // components: { BaseDeleteButton },
  emits: ['update', 'delete'],
  props: {
    template: {
      type: Object as PropType<MailingMailTemplateOverviewRestDto>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    }
  },
  data() {
    return {
      isShowPreview: false as boolean
    }
  },
  computed: {
    hasContentSummary(): boolean {
      return !!this.template.notification_template.content_summary
    }
  },
  methods: {
    setShowPreview(value: boolean): void {
      this.isShowPreview = value
    }
  }
})
